import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import cargandoCard from "../../components/cargando-card";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_LISTAR_ATRAS, ESTILO_INPUT_GENERICO, ESTILO_SECCION_BOTON_DOWN } from "../../utils/const/estilos-const";
import { actualizarListaCorreosAvanzadoFormularioChecklist, actualizarListaTelefonosAvanzadoFormularioChecklist, deshabilitarInputAvanzadoFormularioChecklist, deshabilitarInputFormularioChecklist, deshabilitarOtroFormularioChecklist, deshabilitarSeleccionMultipleFormularioChecklist, guardarAvanzadoFormularioChecklist, guardarInputFormularioChecklist, habilitarInputAvanzadoFormularioChecklist, habilitarInputFormularioChecklist, habilitarOtroFormularioChecklist, habilitarSeleccionMultipleFormularioChecklist, intercambiarPosicionFormularioChecklist, obtenerFormularioChecklist } from "../../api/formulario-checklist";
import Select from "react-select";
import { AVANZADO_FORMULARIO_CHECKLIST, FORMULARIO_CHECKLIST, useSelectFormularioChecklist } from "./const-select-formulario-checklist";
import { ArrowDownCircle, ArrowUpCircle } from "feather-icons-react/build/IconComponents";
import SwitchComponent from "../../components/switch";
import shortid from "shortid";
import { obtenerListaCorreos } from "../../api/correo";
import { obtenerListaTelefono } from "../../api/api-telefono";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";

export default function FormularioChecklistScreen() {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const SELECT_FORMULARIO_CHECKLIST = useSelectFormularioChecklist();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [inputFormularioSelected, setInputFormularioSelected] = useState(null);
    const [listaInputs, setListaInputs] = useState([]);
    const [idChecklist, setIdChecklist] = useState(null);

    const [listaCorreos, setListaCorreos] = useState([]);
    const [listaTelefonos, setListaTelefonos] = useState([]);

    const [correosConductorSelected, setCorreosConductorSelected] = useState(null);
    const [telefonosConductorSelected, setTelefonosConductorSelected] = useState(null);

    const [correosOdometroProximoMantenimientoSelected, setCorreosOdometroProximoMantenimientoSelected] = useState(null);
    const [telefonosOdometroProximoMantenimientoSelected, setTelefonosOdometroProximoMantenimientoSelected] = useState(null);

    const [processingVisible, setProcessingVisible] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            setIdChecklist(data.id);
            let objEnviar = {};
            objEnviar.idChecklist = data.id;
            const infoFormularioChecklist = await obtenerFormularioChecklist(objEnviar);
            // console.log("infoFormularioChecklist");
            // console.log(infoFormularioChecklist);
            if (infoFormularioChecklist.length > 0) {
                let lista = [];
                for (let i = 0; i < infoFormularioChecklist.length; i++) {
                    const element = infoFormularioChecklist[i];
                    let objFormulario = {
                        id: element.id,
                        idChecklist: data.id,
                        idConcepto: element.idConcepto,
                        value: element.idConcepto,
                        label: element.concepto,
                        habilitado: element.habilitado,
                        orden: element.orden,
                        seleccionMultiple: element.seleccionMultiple,
                        otro: element.otro,
                        avanzado: [],
                    };
                    if (element.idConcepto === FORMULARIO_CHECKLIST.SELECCIONAR_CONDUCTOR ||
                        element.idConcepto === FORMULARIO_CHECKLIST.ODOMETRO_PROXIMO_MANTENIMIENTO) {
                        if (Array.isArray(element.avanzado) && element.avanzado.length > 0) {
                            // console.log('element.avanzado 1');
                            // console.log(element.avanzado);
                            objFormulario.avanzado = element.avanzado;
                            const listCorreos = JSON.parse(element.avanzado[0].listaCorreos);
                            const listTelefonos = JSON.parse(element.avanzado[0].listaTelefonos);
                            if (element.idConcepto === FORMULARIO_CHECKLIST.SELECCIONAR_CONDUCTOR) {
                                if (Array.isArray(listCorreos) && listCorreos.length > 0) {
                                    setCorreosConductorSelected(listCorreos);
                                }
                                if (Array.isArray(listTelefonos) && listTelefonos.length > 0) {
                                    setTelefonosConductorSelected(listTelefonos);
                                }
                            }
                            if (element.idConcepto === FORMULARIO_CHECKLIST.ODOMETRO_PROXIMO_MANTENIMIENTO) {
                                if (Array.isArray(listCorreos) && listCorreos.length > 0) {
                                    setCorreosOdometroProximoMantenimientoSelected(listCorreos);
                                }
                                if (Array.isArray(listTelefonos) && listTelefonos.length > 0) {
                                    setTelefonosOdometroProximoMantenimientoSelected(listTelefonos);
                                }
                            }
                        }
                        if (Array.isArray(element.avanzado) && element.avanzado.length === 0) {
                            // console.log('element.avanzado 2');
                            let objValidarConductor = {};
                            objValidarConductor.id = -1;
                            objValidarConductor.idFormularioChecklist = element.id;
                            objValidarConductor.idChecklist = data.id;
                            // objValidarConductor.idConcepto = AVANZADO_FORMULARIO_CHECKLIST.VALIDAR_CONDUCTOR;
                            objValidarConductor.idConcepto = element.idConcepto;
                            objValidarConductor.habilitado = false;
                            objFormulario.avanzado.push(objValidarConductor);
                        }
                    }

                    lista.push(objFormulario);
                }
                setListaInputs(lista);
            }
            const listCorreos = await obtenerListaCorreos(true);
            setListaCorreos(listCorreos);

            const listaTelefonos = await obtenerListaTelefono(true);
            setListaTelefonos(listaTelefonos);
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    const showToast = (message, type = "warning", durationMs = 3000) => {
        setToastMessage(message);
        setToastType(type);
        setToastVisible(true);
        // Auto-hide
        window.clearTimeout(showToast._timer);
        showToast._timer = window.setTimeout(() => {
            setToastVisible(false);
        }, durationMs);
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const handleAgregarClick = async () => {
        // console.log('handleAgregarClick');
        if (inputFormularioSelected === null) {
            return;
        }
        // console.log('inputFormularioSelected');
        // console.log(inputFormularioSelected);
        const existe = listaInputs.find(e => e.value === inputFormularioSelected.value);
        // console.log('existe');
        // console.log(existe);
        if (existe === undefined) {
            let newInput = {
                idChecklist: idChecklist,
                idConcepto: inputFormularioSelected.value,
                value: inputFormularioSelected.value,
                label: inputFormularioSelected.label,
                habilitado: true,
                orden: listaInputs.length,
            };
            const resp = await guardarInputFormularioChecklist(newInput);
            // console.log('guardoNuevo');
            // console.log(guardoNuevo);
            if (resp.error === false) {
                newInput.id = resp.id;
                setListaInputs([...listaInputs, newInput]);
                reset();
            }

        }
        if (existe !== undefined) {
            alert(t('alert_este_tipo_de_input_ya_existe'));
        }
    };

    const renderValidarFormularioAvanzado = (input, index) => {
        try {
            // console.log('renderValidarFormularioAvanzado');
            // console.log(input);
            // console.log(index);
            if (Array.isArray(input.avanzado) && input.avanzado.length > 0) {
                for (let i = 0; i < input.avanzado.length; i++) {
                    const avanzado = input.avanzado[i];
                    // console.log('avanzado');
                    // console.log(avanzado);
                    switch (avanzado.idConcepto) {
                        case AVANZADO_FORMULARIO_CHECKLIST.VALIDAR_CONDUCTOR:
                            return (
                                <>
                                    <div className="flex flex-column">
                                        <div className="flex flex-row ml-8 mt-4"
                                            style={{
                                                width: '30%',
                                            }}
                                        >
                                            <p className="font-bold">{t('label_validar_conductor')}:</p>
                                            <p>&nbsp;</p>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <SwitchComponent isOn={avanzado.habilitado} handleToggle={() => { handleToggleAvanzado(avanzado, index, i); }} />
                                                <p className="ml-4" >{avanzado.habilitado ? t('label_activo') : t('label_no_activo')}</p>
                                            </div>
                                        </div>

                                    </div>
                                    {
                                        avanzado.habilitado === true || avanzado.habilitado === 1 &&
                                        <div className="mt-4"
                                            style={{
                                                width: '50%',
                                            }}
                                        >
                                            <Select
                                                options={listaCorreos}
                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={correosConductorSelected}
                                                onChange={async (e) => {
                                                    // console.log('avanzado');
                                                    // console.log(avanzado);
                                                    const objEnviar = {
                                                        id: avanzado.id,
                                                        listaCorreos: e,
                                                    };
                                                    const resp = await actualizarListaCorreosAvanzadoFormularioChecklist(objEnviar);
                                                    if (resp.error === true) {
                                                        alert(t('alert_ocurrio_un_error_al_actualizar_la_lista_de_correos'));
                                                        return;
                                                    }
                                                    setCorreosConductorSelected(e);
                                                }}
                                                placeholder={t('label_seleccione_correos')}
                                            />
                                        </div>
                                    }
                                    {
                                        avanzado.habilitado === true || avanzado.habilitado === 1 &&
                                        <div className="mt-4"
                                            style={{
                                                width: '50%',
                                            }}
                                        >
                                            <Select
                                                options={listaTelefonos}
                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={telefonosConductorSelected}
                                                onChange={async (e) => {
                                                    const objEnviar = {
                                                        id: avanzado.id,
                                                        listaTelefonos: e,
                                                    };
                                                    const resp = await actualizarListaTelefonosAvanzadoFormularioChecklist(objEnviar);
                                                    if (resp.error === true) {
                                                        alert(t('alert_ocurrio_un_error_al_actualizar_la_lista_de_telefonos'));
                                                        return;
                                                    }
                                                    setTelefonosConductorSelected(e);
                                                }}
                                                placeholder={t('label_seleccione_telefonos')}
                                            />
                                        </div>
                                    }
                                </>
                            );
                        case AVANZADO_FORMULARIO_CHECKLIST.VALIDAR_ODOMETRO_PROXIMO_MANTENIMIENTO:
                            return (
                                <>
                                    <div className="flex flex-column">
                                        <div className="flex flex-row ml-8 mt-4"
                                            style={{
                                                width: '30%',
                                            }}
                                        >
                                            <p className="font-bold">{t('label_validar_odometro')}:</p>
                                            <p>&nbsp;</p>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <SwitchComponent isOn={avanzado.habilitado} handleToggle={() => { handleToggleAvanzado(avanzado, index, i); }} />
                                                <p className="ml-4" >{avanzado.habilitado ? t('label_activo') : t('label_no_activo')}</p>
                                            </div>
                                        </div>

                                    </div>
                                    {
                                        avanzado.habilitado === true || avanzado.habilitado === 1 &&
                                        <div className="mt-4"
                                            style={{
                                                width: '50%',
                                            }}
                                        >
                                            <Select
                                                options={listaCorreos}
                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={correosOdometroProximoMantenimientoSelected}
                                                onChange={async (e) => {
                                                    // console.log('avanzado');
                                                    // console.log(avanzado);
                                                    const objEnviar = {
                                                        id: avanzado.id,
                                                        listaCorreos: e,
                                                    };
                                                    const resp = await actualizarListaCorreosAvanzadoFormularioChecklist(objEnviar);
                                                    if (resp.error === true) {
                                                        alert(t('alert_ocurrio_un_error_al_actualizar_la_lista_de_correos'));
                                                        return;
                                                    }
                                                    setCorreosOdometroProximoMantenimientoSelected(e);
                                                }}
                                                placeholder={t('label_seleccione_correos')}
                                            />
                                        </div>
                                    }
                                    {
                                        avanzado.habilitado === true || avanzado.habilitado === 1 &&
                                        <div className="mt-4"
                                            style={{
                                                width: '50%',
                                            }}
                                        >
                                            <Select
                                                options={listaTelefonos}
                                                isSearchable={true}
                                                isClearable={true}
                                                isMulti={true}
                                                value={telefonosOdometroProximoMantenimientoSelected}
                                                onChange={async (e) => {
                                                    const objEnviar = {
                                                        id: avanzado.id,
                                                        listaTelefonos: e,
                                                    };
                                                    const resp = await actualizarListaTelefonosAvanzadoFormularioChecklist(objEnviar);
                                                    if (resp.error === true) {
                                                        alert(t('alert_ocurrio_un_error_al_actualizar_la_lista_de_telefonos'));
                                                        return;
                                                    }
                                                    setTelefonosOdometroProximoMantenimientoSelected(e);
                                                }}
                                                placeholder={t('label_seleccione_telefonos')}
                                            />
                                        </div>
                                    }
                                </>
                            );
                    }
                }
            }
        } catch (err) {
            console.log('renderValidarFormularioAvanzado err');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    const handleToggleAvanzado = async (avanzado, indexFormulario, indiceAvanzado) => {
        try {
            // console.log('handleToggleAvanzado');
            // console.log(avanzado);
            // console.log(indexFormulario);
            // console.log(indiceAvanzado);
            const nuevoAvanzado = { ...avanzado, habilitado: !avanzado.habilitado };
            setListaInputs(prevLista => {
                return prevLista.map((item, index) => {
                    if (index === indexFormulario) {
                        return {
                            ...item,
                            avanzado: item.avanzado.map((avItem, avIndex) => {
                                if (avIndex === indiceAvanzado) {
                                    return nuevoAvanzado;
                                }
                                return avItem;
                            })
                        };
                    }
                    return item;
                });
            });
            const objEnviar = {
                idFormularioChecklist: avanzado.idFormularioChecklist,
                idChecklist: avanzado.idChecklist,
                idConcepto: avanzado.idConcepto,
                id: avanzado.id,
            };
            if (objEnviar.id === -1) {
                const response = await guardarAvanzadoFormularioChecklist(objEnviar);
                if (response.error === false) {
                    alert(t('alert_se_proceso_correctamente'));
                }
                reset();
                return;
            }
            if (objEnviar.id !== -1) {
                if (avanzado.habilitado === 1 || avanzado.habilitado === true) {
                    const deshabilitado = await deshabilitarInputAvanzadoFormularioChecklist(objEnviar);
                    if (deshabilitado === true) {
                        alert(t('alert_se_proceso_correctamente'));
                        reset();
                    }
                }
                if (avanzado.habilitado === 0 || avanzado.habilitado === false) {
                    const habilito = await habilitarInputAvanzadoFormularioChecklist(objEnviar);
                    if (habilito === true) {
                        alert(t('alert_se_proceso_correctamente'));
                        reset();
                    }
                }
            }
        } catch (err) {
            console.log('handleToggle err');
            console.log(err);
        }
    };

    const renderSeleccionarMultiple = (input, index) => {
        // console.log('renderSeleccionarMultiple');
        // console.log(input);
        // console.log(index);
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '20%',
                        alignItems: 'center',
                        marginTop: '10px',
                    }}
                >
                    <SwitchComponent isOn={input.seleccionMultiple}
                        handleToggle={() => {
                            handleToggleSeleccionMultiple(input, index);
                        }}
                    />
                    <p className="ml-4" >{input.seleccionMultiple ? t('label_multiple') : t('label_no_multiple')}</p>
                </div>
            </>
        );
    };

    const renderSeleccionarOtro = (input, index) => {
        // console.log('renderSeleccionarOtro');
        // console.log(input);
        // console.log(index);
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '20%',
                        alignItems: 'center',
                        marginTop: '10px',
                    }}
                >
                    <SwitchComponent isOn={input.otro}
                        handleToggle={() => {
                            handleToggleSeleccionOtro(input, index);
                        }}
                    />
                    <p className="ml-4" >{input.otro ? t('label_otro') : t('label_no_otro')}</p>
                </div>
            </>
        );
    };

    const renderListInputs = () => {
        try {
            // console.log('renderListInputs');
            // console.log(listaInputs);
            return (
                <>
                    {listaInputs.map((input, index) => (
                        <>
                            <div key={shortid.generate()} className="flex flex-column">
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        width: '100%',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '40%'
                                        }}
                                    >
                                        <label key={input.id} className="font-bold">
                                            {t('label_tipo_input')}:
                                        </label>
                                        <li>{input.label}</li>
                                        <input
                                            type="text"
                                            className={ESTILO_INPUT_GENERICO}
                                            maxLength={255}
                                            placeholder={t('label_ejemplo')}
                                            readOnly
                                        />
                                    </div>
                                    <div
                                        style={{
                                            width: '10%'
                                        }}
                                    >
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            width: '30%',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {index > 0 && <button
                                            type="button"
                                            className={ESTILO_SECCION_BOTON_DOWN}
                                            onClick={() => { moverSeccionUpClick(index); }}
                                            title={t('label_mover_input_arriba')}
                                        >
                                            <ArrowUpCircle />
                                        </button>}

                                        {index < listaInputs.length - 1 &&
                                            <button
                                                type="button"
                                                className={ESTILO_SECCION_BOTON_DOWN}
                                                onClick={() => { moverSeccionDownClick(index); }}
                                                title={t('label_mover_input_abajo')}
                                            >
                                                <ArrowDownCircle />
                                            </button>}

                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            width: '20%',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <SwitchComponent isOn={input.habilitado} handleToggle={() => { handleToggle(input, index); }} />
                                        <p className="ml-4" >{input.habilitado ? t('label_activo') : t('label_no_activo')}</p>
                                    </div>
                                </div>
                            </div>
                            {input.idConcepto === FORMULARIO_CHECKLIST.SELECCIONAR_CONDUCTOR &&
                                renderValidarFormularioAvanzado(input, index)
                            }
                            {input.idConcepto === FORMULARIO_CHECKLIST.ODOMETRO_PROXIMO_MANTENIMIENTO &&
                                renderValidarFormularioAvanzado(input, index)
                            }
                            {input.idConcepto === FORMULARIO_CHECKLIST.RUTA &&
                                <>
                                    {renderSeleccionarMultiple(input, index)}
                                    {renderSeleccionarOtro(input, index)}
                                </>
                            }
                            {input.idConcepto === FORMULARIO_CHECKLIST.PERSONAL_TRANSPORTAR &&
                                <>
                                    {renderSeleccionarMultiple(input, index)}
                                    {renderSeleccionarOtro(input, index)}
                                </>
                            }
                            <br />
                            <hr />
                            <br />
                        </>
                    ))}
                </>
            );
        } catch (err) {
            console.log('render err renderListInputs');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    const handleToggle = async (input) => {
        try {
            // console.log('handleToggle');
            // console.log(input);
            // console.log(index);
            if (input.habilitado === 1 || input.habilitado === true) {
                const deshabilitado = await deshabilitarInputFormularioChecklist(input);
                if (deshabilitado === true) {
                    alert(t('alert_se_proceso_correctamente'));
                    reset();
                }
            }
            if (input.habilitado === 0 || input.habilitado === false) {
                const habilito = await habilitarInputFormularioChecklist(input);
                if (habilito === true) {
                    alert(t('alert_se_proceso_correctamente'));
                    reset();
                }
            }
        } catch (err) {
            console.log('handleToggle err');
            console.log(err);
        }
    };

    const handleToggleSeleccionMultiple = async (input) => {
        try {
            // console.log('handleToggle');
            // console.log(input);
            // console.log(index);
            if (input.seleccionMultiple === 1 || input.seleccionMultiple === true) {
                const deshabilitado = await deshabilitarSeleccionMultipleFormularioChecklist(input);
                if (deshabilitado === true) {
                    showToast(t('alert_se_proceso_correctamente'), 'success');
                    reset();
                }
            }
            if (input.seleccionMultiple === 0 || input.seleccionMultiple === false) {
                const habilito = await habilitarSeleccionMultipleFormularioChecklist(input);
                if (habilito === true) {
                    showToast(t('alert_se_proceso_correctamente'), 'success');
                    reset();
                }
            }
        } catch (err) {
            console.log('handleToggle err');
            console.log(err);
        }
    };

    const handleToggleSeleccionOtro = async (input) => {
        try {
            // console.log('handleToggle');
            // console.log(input);
            // console.log(index);
            if (input.otro === 1 || input.otro === true) {
                const deshabilitado = await deshabilitarOtroFormularioChecklist(input);
                if (deshabilitado === true) {
                    showToast(t('alert_se_proceso_correctamente'), 'success');
                    reset();
                }
            }
            if (input.otro === 0 || input.otro === false) {
                const habilito = await habilitarOtroFormularioChecklist(input);
                if (habilito === true) {
                    showToast(t('alert_se_proceso_correctamente'), 'success');
                    reset();
                }
            }
        } catch (err) {
            console.log('handleToggleSeleccionOtro err');
            console.log(err);
        }
    };

    const moverSeccionUpClick = async (index) => {
        // console.log('moverSeccionUpClick');
        // console.log(index);
        if (index === 0) return; // No mover si es el primer elemento
        let objEnviar = {};
        objEnviar.objetoA = listaInputs[index];
        objEnviar.objetoB = listaInputs[index - 1];
        const intercambiar = await intercambiarPosicionFormularioChecklist(objEnviar);
        if (intercambiar === true) {
            reset();
        }
        if (intercambiar === false) {
            alert(t('alert_no_se_pudo_procesar'));
        }
    };

    const moverSeccionDownClick = async (index) => {
        // console.log('moverSeccionDownClick');
        // console.log(index);
        if (index === listaInputs.length - 1) return; // No mover si es el último elemento
        let objEnviar = {};
        objEnviar.objetoA = listaInputs[index];
        objEnviar.objetoB = listaInputs[index + 1];
        const intercambiar = await intercambiarPosicionFormularioChecklist(objEnviar);
        if (intercambiar === true) {
            reset();
        }
        if (intercambiar === false) {
            alert(t('alert_no_se_pudo_procesar'));
        }
    };

    const reset = () => {
        setCargandoPage(true);
        iniciar();
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="pt-4 px-4 " >
                    <div className="flex justify-between">
                        <div className="flex justify-center align-center">
                            <label
                                style={{
                                    paddingLeft: 10,
                                    fontWeight: 'bold',
                                }}
                            >
                                {t('titulo_formulario_checklist')}
                            </label>
                        </div>
                        <div className="flex justify-center">
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={handleAtrasClick}
                            >
                                {t('btn_atras')}
                            </button>
                        </div>
                    </div>
                    <hr />
                    <br />
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                            <label className="font-bold">{t('label_seleccione_input')}</label>
                            <div
                                className="flex"
                            >
                                <Select
                                    options={SELECT_FORMULARIO_CHECKLIST}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={inputFormularioSelected}
                                    onChange={(e) => {
                                        setInputFormularioSelected(e);
                                    }}
                                    placeholder={t('label_seleccione_input')}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            width: '350px' // Set your desired width here
                                        })
                                    }}
                                />
                                <div
                                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                                    style={{ marginRight: '16px' }}
                                >
                                    <button
                                        type="button"
                                        onClick={handleAgregarClick}
                                    >
                                        {t('btn_agregar')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <hr />
                    {renderListInputs()}
                    <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
                    <ToastComponent
                        visible={toastVisible}
                        message={toastMessage}
                        type={toastType}
                        onClose={() => setToastVisible(false)}
                    />
                </div>
            );
        } catch (err) {
            console.log('render err ChecklistScreen');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    return render();
}